<template>
  <dialog-info
    ref="dialog"
    :title="title"
    :isLoading="isLoading"
  >
    <stock-card
      :data="data"
      :model="StockModel"
      :hasCreateNew="false"
      disabled
    />
  </dialog-info>
</template>

<script>
import { ModelStock } from '@/services/Stocks'
import { api } from '@/services/api'

export default {
  name: 'DialogStockCard',
  components: {
    'dialog-info': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogInfo'),
    'stock-card': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/Stock/form.vue')
  },
  data () {
    return {
      isLoading: false,
      stockID: null,
      data: {}
    }
  },
  computed: {
    title () {
      return this.L10n('stock')
    }
  },
  methods: {
    StockModel () {
      return new ModelStock()
    },
    show (stockID) {
      this.stockID = stockID
      this.loadData()
      this.$refs['dialog'].show()
    },
    hide () {
      this.$refs['dialog'].hide()
    },
    loadData () {
      this.isLoading = true
      return api
        .get(`Stocks/Get/${this.stockID}`)
        .then(({ data }) => {
          this.data = data
        })
        .catch((err) => {
          this.data = {}
          this.requestErrorHandler(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
